import { Component, Input } from '@angular/core';
import { Notification } from '../../interfaces';
import { Store } from '@ngrx/store';

import * as fromRoot from '../../reducers';
import * as notifications from '../../actions/notifications';

@Component({
  selector: 'edge-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {
  isDismissed = false;
  @Input() data: any;

  constructor(private store: Store<fromRoot.State>) {}

  closeNotification(): void {
    this.isDismissed = true;
    setTimeout(() => {
      this.store.dispatch(notifications.RemoveNotification(this.data.id));
    }, 500);
  }
}
